<div class="cookie-overlay" *ngIf="showBanner">
  <div class="cookie-banner">
    <div class="cookie-banner__content">
      <div class="cookie-banner__text" [innerHTML]="('COOKIE.BANNER_TEXT' | translate)"></div>
      <div class="cookie-banner__actions">
        <button class="btn btn-link" (click)="useOnlyNecessary()">{{ 'COOKIE.ONLY_NECESSARY' | translate }}</button>
        <button class="btn btn-secondary" (click)="openManage()">{{ 'COOKIE.MANAGE' | translate }}</button>
        <button class="btn" [ngClass]="{'btn-primary': !henterPantMode, 'btn-primary-henterpant': henterPantMode}" (click)="allowAll()">{{ 'COOKIE.ALLOW' | translate }}</button>
      </div>
    </div>
  </div>
  
</div>

<ngx-smart-modal identifier="cookieManageModal" 
                 [dismissable]="true" [customClass]="'cookie-manage-modal'" 
                 (onAnyCloseEvent)="modalClosed()">
  <div class="cookie-manage">
    <h3>{{ 'COOKIE.MANAGE_TITLE' | translate }}</h3>

    <div class="cookie-manage__group">
      <div class="cookie-manage__row">
        <div>
          <div class="cookie-manage__label">{{ 'COOKIE.REQUIRED' | translate }}</div>
          <div class="cookie-manage__desc">{{ 'COOKIE.REQUIRED_DESC' | translate }}</div>
        </div>
        <div>
          <div class="toggle toggle--locked"></div>
        </div>
      </div> 

      <div class="cookie-manage__row">
        <div>
          <div class="cookie-manage__label">{{ 'COOKIE.FUNCTIONAL' | translate }}</div>
          <div class="cookie-manage__desc">{{ 'COOKIE.FUNCTIONAL_DESC' | translate }}</div>
        </div>
        <div>
          <label class="switch">
            <input type="checkbox" [(ngModel)]="functional">
            <span class="slider round"></span>
          </label>
        </div>
      </div>

      <div class="cookie-manage__row">
        <div>
          <div class="cookie-manage__label">{{ 'COOKIE.ANALYTICS' | translate }}</div>
          <div class="cookie-manage__desc">{{ 'COOKIE.ANALYTICS_DESC' | translate }}</div>
        </div>
        <div>
          <label class="switch">
            <input type="checkbox" [(ngModel)]="analytics">
            <span class="slider round"></span>
          </label>
        </div>
      </div>

      <div class="cookie-manage__row">
        <div>
          <div class="cookie-manage__label">{{ 'COOKIE.MARKETING' | translate }}</div>
          <div class="cookie-manage__desc" [innerHTML]="('COOKIE.MARKETING_DESC' | translate)"></div>
        </div>
        <div>
          <label class="switch">
            <input type="checkbox" [(ngModel)]="marketing">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </div>

    <div class="cookie-manage__footer mt-5">
      <button class="btn btn-primary" (click)="saveManage()">{{ 'COOKIE.SAVE' | translate }}</button>
    </div>
  </div>
</ngx-smart-modal>


